import "./styles.css";
import { Box, Container, Grid, Typography, styled } from "@mui/material";
import ResetPasswordBg from "./images/reset.svg";
import { LoadingButton } from "@mui/lab";
import LoginPageCard from "../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../shared/components/auth/menuContainer";
import LoginLine from "../../../../src/assets/img/login-line.svg";

const StyledMenuBg = styled(Box)(
  ({ theme }) => `
    top: 0;
    background: transparent;
    padding: 0 10%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
    color: rgba(15, 41, 85, 0.20);
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 275;
    line-height: normal;
    margin-top: 0;
    }.
     img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  `
);

const ContentBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  gap: "1rem",
  "& .MuiTypography-h2": {
    fontSize: "32px !important",
    fontWeight: 600,
    color: "313131",
    paddingTop: "24px",
  },
  "& .MuiTypography-body1": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#7B7583",
  },
});

const StyledImage = styled("img")({
  maxWidth: "100%",
  margin: "24px auto",
  display: "flex",
  justifyContent: "center",
});

const ResetSuccess = (props: any) => {
  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginTop: "12.5%",
            }}
          >
            <Grid item md={4}>
              <MenuContainer />
              <StyledMenuBg>
                <h2> Password Reset Successfully</h2>
              </StyledMenuBg>
              <Typography
                variant="body1"
                sx={{ textAlign: "center" }}
              >
                Your password has been successfully reset.{" "}
              </Typography>
            </Grid>
            <Grid item md={0.75}>
              <img style={{ padding: "0 12px" }} src={LoginLine} alt="Logo" />
            </Grid>
            <Grid item md={4}>
              <StyledImage src={ResetPasswordBg} className="img-fluid" alt="" />
              <Grid
                container
                sx={{
                  justifyContent: "center",
                  alignItems: "end",
                }}
              >
                <Grid item md={6} sx={{ mt: 2 }}>
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    fullWidth
                    size="small"
                    aria-label="Click here to login."
                    href="/admin/login"
                  >
                    Go to login
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ResetSuccess;
